export function normalizeSearch(value) {
  return (value || '').trim().toLowerCase();
}

export function filterBySearch(items, query, fields = []) {
  const q = normalizeSearch(query);
  if (!q) return items;

  return items.filter((item) => fields.some((field) => {
    const value = typeof field === 'function' ? field(item) : item[field];
    return normalizeSearch(value).includes(q);
  }));
}
